import { useCallback, useEffect, useRef, useState } from "react";
import { CommunityAdminSection } from "../../pages/communityAdmin/enums/CommunityAdminSection";
import { getAdminDiscussions } from "../../services/communityService";
import { AdminDiscussionListModel } from "./models/AdminDiscussionListModel";
import { ApiArrayResponseModel } from "./models/ApiResponseModel";
import { useSearch } from "./useSearch";

export const useCommunityAdminList = (section: CommunityAdminSection, search: string, page: number = 1, limit: number = 10) => {
    const isMountedRef = useRef(true);
    const searchValue = useSearch(search);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<ApiArrayResponseModel<AdminDiscussionListModel> | null>(null);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);


    const load = useCallback(async () => {
        try {
            setLoading(true);
            const offset = (page - 1) * limit;
            const _data: ApiArrayResponseModel<AdminDiscussionListModel> = await getAdminDiscussions(
                section === CommunityAdminSection.Mastermind ? 'circle': 'forum', 
                searchValue,
                limit,
                offset
            );
            if(!isMountedRef.current)
                return;
            setData(_data);
        }
        catch {}
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [searchValue, section, page, limit]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, data, load }
}